"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const getContributionsDataTypes = graphql_tag_1.default `
  query($environmentId: String!) {
    getContributionsDataTypes(environmentId: $environmentId) {
      type
      environmentId
    }
  }
`;
exports.default = getContributionsDataTypes;
//# sourceMappingURL=getContributionsDataTypes.js.map